var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-iframe",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.currentTitle !== ""
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-title",
                        },
                        [_vm._v(_vm._s(_vm.currentTitle))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("iframe", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.currentUrl.includes("http"),
                        expression: "currentUrl.includes('http')",
                      },
                    ],
                    attrs: {
                      src: _vm.activeUrl,
                      height: _vm.currentHeight,
                      width: "100%",
                      allowfullscreen: "",
                      sandbox:
                        "allow-forms allow-popups allow-pointer-lock allow-same-origin allow-scripts",
                    },
                  }),
                  _vm._v(" "),
                  _vm.currentCcInfo
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-block-iframe-cc-data",
                        },
                        [
                          _c("span", {
                            staticClass: "cw-block-iframe-cc",
                            class: ["cw-block-iframe-cc-" + _vm.currentCcInfo],
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "cw-block-iframe-cc-infos",
                            },
                            [
                              _vm.currentCcWork
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$gettext("Werk")) +
                                        ": " +
                                        _vm._s(_vm.currentCcWork)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentCcAuthor
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(_vm.$gettext("Autor")) +
                                        ": " +
                                        _vm._s(_vm.currentCcAuthor)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.currentCcBase
                                ? _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$gettext("Lizenz der Plattform")
                                      ) +
                                        ": " +
                                        _vm._s(_vm.currentCcBase)
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.currentUrl.includes("http"),
                        expression: "!currentUrl.includes('http')",
                      },
                    ],
                    style: {
                      height: _vm.currentHeight + "px",
                    },
                  }),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Grunddaten"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Titel")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentTitle,
                                          expression: "currentTitle",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentTitle,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentTitle = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("URL")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentUrl,
                                          expression: "currentUrl",
                                        },
                                      ],
                                      attrs: {
                                        type: "text",
                                      },
                                      domProps: {
                                        value: _vm.currentUrl,
                                      },
                                      on: {
                                        change: _vm.updateUrl,
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentUrl = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Höhe")) +
                                        "\n                            "
                                    ),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.currentHeight,
                                          expression: "currentHeight",
                                        },
                                      ],
                                      attrs: {
                                        type: "number",
                                        min: "0",
                                      },
                                      domProps: {
                                        value: _vm.currentHeight,
                                      },
                                      on: {
                                        input: function input($event) {
                                          if ($event.target.composing) return
                                          _vm.currentHeight =
                                            $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Nutzerspezifische ID"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Nutzerspezifische ID übergeben"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentSubmitUserId,
                                            expression: "currentSubmitUserId",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentSubmitUserId = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "false",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentSubmitUserId === "true"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Name des Übergabeparameters"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentSubmitParam,
                                              expression: "currentSubmitParam",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentSubmitParam,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentSubmitParam =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentSubmitUserId === "true"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Zufallszeichen für Verschlüsselung (Salt)"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentSalt,
                                              expression: "currentSalt",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentSalt,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentSalt =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 2,
                                name: _vm.$gettext("Creative Commons"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Creative Commons Lizenz"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentCcInfo,
                                            expression: "currentCcInfo",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentCcInfo = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "false",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Keine"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "(by) " +
                                                _vm._s(
                                                  _vm.$gettext("Namensnennung")
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by-sa",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    (by-sa) " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Namensnennung & Weitergabe unter gleichen Bedingungen"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by-nc",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    (by-nc) " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Namensnennung & Nicht kommerziell"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by-nd",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    (by-nd) " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Namensnennung & Keine Bearbeitung"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by-nc-nd",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    (by-nc-nd)\n                                    " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Namensnennung & Nicht kommerziell & Keine Bearbeitung"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "by-nc-sa",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    (by-nc-sa)\n                                    " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Namensnennung & Nicht kommerziell & Weitergabe unter gleichen Bedingungen"
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.currentCcInfo !== "false"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            CC " +
                                            _vm._s(_vm.$gettext("Werk")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentCcWork,
                                              expression: "currentCcWork",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentCcWork,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentCcWork =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentCcInfo !== "false"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            CC " +
                                            _vm._s(_vm.$gettext("Author")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentCcAuthor,
                                              expression: "currentCcAuthor",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentCcAuthor,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentCcAuthor =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentCcInfo !== "false"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            CC " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Lizenz der Plattform"
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentCcBase,
                                              expression: "currentCcBase",
                                            },
                                          ],
                                          attrs: {
                                            type: "text",
                                          },
                                          domProps: {
                                            value: _vm.currentCcBase,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentCcBase =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum IFrame-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }